var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.ActiveTabIndex == 0) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "new-allocation-panel"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Allocation Panel")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.IsDelivery) ? _c('div', [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation') : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('RVP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-allocationv2', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData
    }
  }, [_vm._v(_vm._s(_vm.ActiveTabIndex))]) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)])], 1)]) : _c('div', {
    staticClass: "row",
    attrs: {
      "id": "new-allocation-panel"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show('first')),
      expression: "show('first')"
    }],
    class: ['p-3 text-white', _vm.firstClass]
  }, [_c('legend', {
    staticClass: "w-100 d-flex justify-content-between align-items-center"
  }, [_vm._v("\n                Allocation Panel\n                "), _c('div', [(_vm.layout === 'half') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.expand('first')
      }
    }
  }, [_vm._v("\n                        +\n                    ")]) : (_vm.layout === 'first') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.collapse()
      }
    }
  }, [_vm._v("\n                        −\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.IsDelivery) ? _c('div', [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation') : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('RVP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-allocationv2', {
    attrs: {
      "srList": _vm.srList,
      "hyperVMsgData": _vm.hyperVMsgData
    }
  }, [_vm._v(_vm._s(_vm.ActiveTabIndex))]) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show('second') || _vm.ActiveTabIndex == 1),
      expression: "show('second') || ActiveTabIndex == 1"
    }],
    class: ['p-3 text-white', _vm.secondClass]
  }, [_c('legend', {
    staticClass: "w-100 d-flex justify-content-between align-items-center"
  }, [_vm._v("\n                Confirm Allocation\n                "), _c('div', [(_vm.layout === 'half') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.expand('second')
      }
    }
  }, [_vm._v("\n                        +\n                    ")]) : (_vm.layout === 'second') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.collapse()
      }
    }
  }, [_vm._v("\n                        −\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab tabsborder",
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Confirm allocation to SR"
    }
  }, [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab tabsborder",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.IsDelivery) ? _c('div', [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation') : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RVP"
    },
    on: {
      "click": function($event) {
        return _vm.SwitchTabs('RVP')
      }
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-confirmallocation', {
    attrs: {
      "srList": _vm.srList
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "All OFP"
    }
  }, [(_vm.IsRVP) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.rvpUserLoading
    },
    on: {
      "update:active": function($event) {
        _vm.rvpUserLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.ActiveTabIndex == 1 && _vm.srList.length > 0) ? _c('Reverse-allofp', {
    attrs: {
      "srList": _vm.srList
    }
  }) : _vm._e()], 1) : _c('div', [_c('span', [_vm._v("Allocation Panel is not available for this HUB,Kindly reach out to Tech Support")])])])], 1)], 1)])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51152f7d","hasScoped":true}!./src/views/components/newallocationpagev2/newallocationpagev2.component.html
// module id = 1518
// module chunks = 1